import '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';
import { d as IconHomeSolid } from '../index-1707f584.js';
import { Icon } from './icon.js';
import { Button } from './button.js';
import { Overlay } from './overlay.js';

var styles = {
raw: ".hcr-panel-1-6-0{position:fixed;top:0;right:0;bottom:0;left:0;-webkit-transform:translateY(100%);transform:translateY(100%);-webkit-transition:opacity 125ms,-webkit-transform 62.5ms 62.5ms;transition:opacity 125ms,-webkit-transform 62.5ms 62.5ms;transition:transform 62.5ms 62.5ms,opacity 125ms;transition:transform 62.5ms 62.5ms,opacity 125ms,-webkit-transform 62.5ms 62.5ms;opacity:0;z-index:1209}.hcr-panel--active-1-6-0{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transition:opacity 62.5ms 62.5ms,-webkit-transform 125ms;transition:opacity 62.5ms 62.5ms,-webkit-transform 125ms;transition:transform 125ms,opacity 62.5ms 62.5ms;transition:transform 125ms,opacity 62.5ms 62.5ms,-webkit-transform 125ms;opacity:1}.hcr-panel__body-1-6-0{position:absolute;top:0;right:0;bottom:0;width:100%;-webkit-transform:translateY(100%);transform:translateY(100%);-webkit-transition:-webkit-transform .25s ease;transition:-webkit-transform .25s ease;transition:transform .25s ease;transition:transform .25s ease,-webkit-transform .25s ease;background:#fff;-webkit-box-shadow:0 0 12px rgba(0,0,0,.12);box-shadow:0 0 12px rgba(0,0,0,.12);overflow:hidden;z-index:1209}@media (min-width:600px){.hcr-panel__body-1-6-0{width:380px;-webkit-transform:translate(100%);transform:translate(100%)}}.hcr-panel--left-1-6-0 .hcr-panel__body-1-6-0{right:auto;left:0}@media (min-width:600px){.hcr-panel--left-1-6-0 .hcr-panel__body-1-6-0{-webkit-transform:translate(-100%);transform:translate(-100%)}}.hcr-panel--active-1-6-0 .hcr-panel__body-1-6-0{-webkit-transform:translate(0);transform:translate(0);-webkit-transition:-webkit-transform .25s ease .25s;transition:-webkit-transform .25s ease .25s;transition:transform .25s ease .25s;transition:transform .25s ease .25s,-webkit-transform .25s ease .25s}.hcr-panel__header-1-6-0{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;position:absolute;top:0;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;width:100%;height:60px;padding-right:24px;padding-left:24px;background:#73d700}.hcr-panel__title-1-6-0{padding:0 12px;color:#fff;font-size:18px;font-weight:400;line-height:1.1;text-align:center}.hcr-panel__back-1-6-0,.hcr-panel__close-1-6-0{margin:0 -2px;padding:0;border:0;background:none;color:#fff;font-size:16px;line-height:60px;cursor:pointer;overflow:visible}.hcr-panel__close-1-6-0{display:inline-block;width:24px;height:24px;content:\"\";vertical-align:middle;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M846.4 799.1L535.9 488.6l310.5-310.9a29.1 29.1 0 00-41.4-41.3L494.1 446.8 181.8 136.4a29.5 29.5 0 00-41.3 0 27.3 27.3 0 00-8.7 20.4 28.2 28.2 0 008.7 20.9l314 310.9-312.2 310.9a29.5 29.5 0 0020.9 50 29.1 29.1 0 0018.6-8.6l310.5-310.4 310.9 310.4a29.1 29.1 0 0041.3 0 28.6 28.6 0 001.9-41.8z' fill='rgba(255, 255, 255, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%;background-size:20px}.hcr-panel__close-1-6-0 .hcr-icon-1-6-0{display:none}.hcr-panel__content-1-6-0{max-height:100%;padding:72px 12px;background:#fff;overflow-y:auto}@media (min-width:600px){.hcr-panel__content-1-6-0{padding:84px 24px}}.hcr-panel__footer-1-6-0{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;position:absolute;bottom:0;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;width:100%;height:60px;padding:0 12px;background:#fff;text-align:center;-webkit-box-shadow:0 0 12px rgba(0,0,0,.12);box-shadow:0 0 12px rgba(0,0,0,.12)}@media (min-width:600px){.hcr-panel__footer-1-6-0{padding:0 24px}}.hcr-panel__footer-section-1-6-0{margin:0 6px}@media (min-width:0){.hcr-panel__footer-section-1-6-0{margin:0 6px}}.hcr-panel__overlay-1-6-0{position:absolute}.hcr-panel__back-1-6-0 svg{fill:#fff}",
map:{"hcr-panel":"hcr-panel-1-6-0","hcr-panel--active":"hcr-panel--active-1-6-0","hcr-panel__body":"hcr-panel__body-1-6-0","hcr-panel--left":"hcr-panel--left-1-6-0","hcr-panel__header":"hcr-panel__header-1-6-0","hcr-panel__title":"hcr-panel__title-1-6-0","hcr-panel__back":"hcr-panel__back-1-6-0","hcr-panel__close":"hcr-panel__close-1-6-0","hcr-icon":"hcr-icon-1-6-0","hcr-panel__content":"hcr-panel__content-1-6-0","hcr-panel__footer":"hcr-panel__footer-1-6-0","hcr-panel__footer-section":"hcr-panel__footer-section-1-6-0","hcr-panel__overlay":"hcr-panel__overlay-1-6-0"}};

var bemPanel = Bem('panel', styles);
var Panel = function Panel(_ref) {
  var children = _ref.children,
      active = _ref.active,
      hasOverlay = _ref.hasOverlay,
      title = _ref.title,
      onHeaderBtnClick = _ref.onHeaderBtnClick,
      headerBtnIcon = _ref.headerBtnIcon,
      onCloseBtnClick = _ref.onCloseBtnClick,
      onOverlayClick = _ref.onOverlayClick,
      primaryBtnText = _ref.primaryBtnText,
      onPrimaryBtnClick = _ref.onPrimaryBtnClick,
      secondaryBtnText = _ref.secondaryBtnText,
      onSecondaryBtnClick = _ref.onSecondaryBtnClick,
      extraClasses = _ref.extraClasses,
      position = _ref.position;
  // defines panel header template and it's controls
  var panelHeader = React.createElement("div", {
    className: bemPanel.e('header')
  }, onHeaderBtnClick && React.createElement("button", {
    type: "button",
    className: bemPanel.e('back'),
    onClick: onHeaderBtnClick
  }, React.createElement(Icon, {
    InlineIcon: headerBtnIcon
  })), typeof title === 'function' ? title() : React.createElement("h3", {
    className: bemPanel.e('title')
  }, title), onCloseBtnClick && React.createElement("button", {
    type: "button",
    className: bemPanel.e('close'),
    onClick: onCloseBtnClick
  })); // defines panel content area template that holds passed children

  var panelBody = React.createElement("div", {
    className: bemPanel.e('content')
  }, children); // defines panel footer template and it's controls

  var panelFooter = React.createElement("div", {
    className: bemPanel.e('footer')
  }, onSecondaryBtnClick && React.createElement("div", {
    className: bemPanel.e('footer-section')
  }, React.createElement(Button, {
    appearance: "tertiary",
    onClick: onSecondaryBtnClick
  }, secondaryBtnText)), onPrimaryBtnClick && React.createElement("div", {
    className: bemPanel.e('footer-section')
  }, React.createElement(Button, {
    appearance: "primary",
    onClick: onPrimaryBtnClick
  }, primaryBtnText)));
  return React.createElement("div", {
    className: bemPanel.b({
      active: active,
      left: position === 'left'
    }, extraClasses)
  }, React.createElement("div", {
    className: bemPanel.e('body')
  }, panelHeader, panelBody, primaryBtnText && panelFooter), hasOverlay && React.createElement(Overlay, {
    extraClasses: bemPanel.e('overlay'),
    onClick: onOverlayClick
  }));
};
Panel.displayName = 'Panel';
Panel.defaultProps = {
  active: null,
  hasOverlay: false,
  extraClasses: null,
  onHeaderBtnClick: null,
  headerBtnIcon: IconHomeSolid,
  onCloseBtnClick: null,
  onOverlayClick: null,
  primaryBtnText: undefined,
  onPrimaryBtnClick: null,
  secondaryBtnText: null,
  onSecondaryBtnClick: null,
  position: null
};
Panel.propTypes = {
  /** content of the panel body */
  children: PropTypes.node.isRequired,

  /** toggles Panel visibility */
  active: PropTypes.bool,

  /** toggles Panel overlay */
  hasOverlay: PropTypes.bool,

  /** title of the Panel, displayed in panel header,
   * you can pass a custom component with the render function */
  title: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,

  /** custom handler for home/back button click, the button won't render if not specified */
  onHeaderBtnClick: PropTypes.func,

  /** custom icon for back button in panel's header, needs to be an svg inline icon component */
  headerBtnIcon: PropTypes.func,

  /** custom handler for close button click, the button won't render if not specified */
  onCloseBtnClick: PropTypes.func,

  /** custom overlay click handler */
  onOverlayClick: PropTypes.func,

  /** primary action button text */
  primaryBtnText: PropTypes.string,

  /** custom handler for primary action button click, the button won't render if not specified */
  onPrimaryBtnClick: PropTypes.func,

  /** secondary action button text */
  secondaryBtnText: PropTypes.string,

  /** custom handler for secondary action button click */
  onSecondaryBtnClick: PropTypes.func,

  /** custom classes name for panel element */
  extraClasses: PropTypes.string,

  /** Controls panel positioning, right side of the screen is the default positioning */
  position: PropTypes.oneOf(['left'])
};
var panel = Injecss(Panel, styles);

export { panel as Panel };
